import React from 'react';
import './CariOdemeTahsilatDetayModal.css';
import { getUserRoleLabel } from '../constants/userRoles';

const ODEME_YONTEMI_LABELS = {
  Nakit: 'Nakit',
  HavaleEFT: 'Havale/EFT',
  KrediKarti: 'Kredi Kartı',
  CekSenet: 'Çek/Senet',
};

const formatDateTime = (dateValue) => {
  if (!dateValue) return '—';
  try {
    const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
    if (!date || isNaN(date.getTime())) return '—';
    return date.toLocaleString('tr-TR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
};

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '—';
  return `${parseFloat(amount).toFixed(2)} ₺`;
};

const formatKullanici = (adSoyad, kullaniciAdi, rol) => {
  const ad = adSoyad || kullaniciAdi || '—';
  const rolLabel = rol ? getUserRoleLabel(rol) : null;
  return rolLabel ? `${ad} (${rolLabel})` : ad;
};

const IslemSection = ({ title, islem, variant = 'default' }) => {
  if (!islem) return null;
  return (
    <div className={`cari-od-tah-detay__section cari-od-tah-detay__section--${variant}`}>
      <div className="cari-od-tah-detay__section-title">{title}</div>
      <div className="cari-od-tah-detay__grid">
        <div className="cari-od-tah-detay__item">
          <span>Tutar</span>
          <strong>{formatCurrency(islem.tutar)}</strong>
        </div>
        <div className="cari-od-tah-detay__item">
          <span>Ödeme yöntemi</span>
          <strong>{ODEME_YONTEMI_LABELS[islem.odemeYontemi] || islem.odemeYontemi || '—'}</strong>
        </div>
        <div className="cari-od-tah-detay__item">
          <span>Tarih</span>
          <strong>{formatDateTime(islem.olusturmaTarihi)}</strong>
        </div>
        <div className="cari-od-tah-detay__item cari-od-tah-detay__item--full">
          <span>İşlemi yapan</span>
          <strong>
            {formatKullanici(islem.olusturanAdSoyad, islem.olusturanKullaniciAdi, islem.olusturanRol)}
          </strong>
        </div>
        {islem.aciklama ? (
          <div className="cari-od-tah-detay__item cari-od-tah-detay__item--full">
            <span>Açıklama</span>
            <strong>{islem.aciklama}</strong>
          </div>
        ) : null}
        {islem.odemeNotu ? (
          <div className="cari-od-tah-detay__item cari-od-tah-detay__item--full">
            <span>Not</span>
            <strong className="cari-od-tah-detay__note">{islem.odemeNotu}</strong>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const CariOdemeTahsilatDetayModal = ({ hareket, teknikServisAdi, onClose }) => {
  if (!hareket) return null;

  const isTahsilat = hareket.hareketTipi === 'Tahsilat';
  const isIptalHareketi = !!hareket.iptalMi;
  const isIptalEdildi = !!hareket.iptalEdildiMi;

  const title = isIptalHareketi
    ? `${hareket.hareketTipi} İptali`
    : `${hareket.hareketTipi} Detayı`;

  const icon = isTahsilat ? 'fa-hand-holding-usd' : 'fa-money-bill-wave';
  const iconClass = isTahsilat ? 'is-tahsilat' : 'is-odeme';

  const anaIslem = isIptalHareketi
    ? hareket.orijinalIslem
    : {
        tutar: hareket.tutar,
        odemeYontemi: hareket.odemeYontemi,
        odemeNotu: hareket.odemeNotu,
        aciklama: hareket.aciklama,
        olusturmaTarihi: hareket.olusturmaTarihi,
        olusturanAdSoyad: hareket.olusturanAdSoyad,
        olusturanKullaniciAdi: hareket.olusturanKullaniciAdi,
        olusturanRol: hareket.olusturanRol,
      };

  return (
    <div className="modal-overlay cari-od-tah-detay-modal" onClick={onClose} role="presentation">
      <div
        className="modal-content cari-od-tah-detay-modal__panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="cari-od-tah-detay-title">
        <div className="modal-header cari-od-tah-detay-modal__header">
          <h2 id="cari-od-tah-detay-title">
            <span className={`cari-od-tah-detay-modal__header-icon ${iconClass}`}>
              <i className={`fas ${icon}`} aria-hidden="true" />
            </span>
            {title}
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </div>

        <div className="modal-body">
          {isIptalHareketi ? (
            <div className="cari-od-tah-detay__banner cari-od-tah-detay__banner--iptal">
              <i className="fas fa-undo" aria-hidden="true" />
              Bu kayıt, aşağıdaki orijinal {hareket.hareketTipi.toLowerCase()} işleminin iptal hareketidir.
            </div>
          ) : null}
          {isIptalEdildi && !isIptalHareketi ? (
            <div className="cari-od-tah-detay__banner cari-od-tah-detay__banner--cancelled">
              <i className="fas fa-ban" aria-hidden="true" />
              Bu {hareket.hareketTipi.toLowerCase()} işlemi iptal edilmiştir.
            </div>
          ) : null}

          <div className="cari-od-tah-detay__context">
            <span className="cari-od-tah-detay__context-label">Teknik Servis</span>
            <div className="cari-od-tah-detay__context-name">{teknikServisAdi || '—'}</div>
            <div className="cari-od-tah-detay__badges">
              <span className={`cari-od-tah-detay__type-badge ${isTahsilat ? 'is-tahsilat' : 'is-odeme'}`}>
                {hareket.hareketTipi}
              </span>
              {isIptalHareketi ? (
                <span className="cari-od-tah-detay__type-badge is-iptal">İptal Hareketi</span>
              ) : null}
            </div>
          </div>

          <IslemSection
            title={isIptalHareketi ? 'Orijinal işlem' : 'İşlem bilgileri'}
            islem={anaIslem}
            variant={isIptalHareketi ? 'original' : 'default'}
          />

          {isIptalHareketi ? (
            <IslemSection
              title="İptal işlemi"
              islem={{
                tutar: hareket.tutar,
                odemeYontemi: hareket.odemeYontemi,
                odemeNotu: hareket.odemeNotu,
                aciklama: hareket.aciklama,
                olusturmaTarihi: hareket.olusturmaTarihi,
                olusturanAdSoyad: hareket.olusturanAdSoyad,
                olusturanKullaniciAdi: hareket.olusturanKullaniciAdi,
                olusturanRol: hareket.olusturanRol,
              }}
              variant="iptal"
            />
          ) : null}

          {isIptalEdildi && hareket.iptalBilgisi ? (
            <IslemSection title="İptal bilgisi" islem={hareket.iptalBilgisi} variant="iptal" />
          ) : null}
        </div>

        <div className="modal-footer">
          <button type="button" className="secondary-btn" onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    </div>
  );
};

export default CariOdemeTahsilatDetayModal;
